"use strict";

angular.module("core").directive('ignoreDirty', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
            ctrl.$setPristine = function() {};
            ctrl.$pristine = false;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/ignore-dirty/ignore-dirty.directive.js
// module id = 488
// module chunks = 0